import typography from '../typography'

export default {
  root: {
    ...typography.body1,
    borderBottom: 0,
    padding: '16px 11px'
  }
}
